import { getMessage, getOrderFields } from "../selectors";
import fetch from "~/utils/fetch";
import { CartItem, CostValues } from "~/cart/types";
import { TFunction } from "next-i18next";
import { Field } from "~/tenant/types";
import { PaymentMethods } from "@pency/api/orders/types";

export default {
  create: (
    slug: string,
    {
      items,
      orderId,
      fields,
      preference = null,
      t,
      mapPrices,
      couponInfo,
      country = undefined as string | undefined,
    }
  ) =>
    fetch("POST", "/api/order", {
      slug,
      order: {
        id: orderId,
        message: getMessage(
          items,
          orderId,
          t,
          mapPrices,
          couponInfo,
          fields,
          undefined,
          preference ?? undefined,
          country
        ),
      },
    })
      .then(() => console.info("Order sent correctly"))
      .catch(() => console.warn("Order failed")),
  saveOrder: async (
    items: CartItem[],
    orderId: string,
    tenantId: string,
    createdAt: number,
    currency: string,
    mapPrices: CostValues,
    fields: Field[],
    paymentMethod: PaymentMethods,
    t: TFunction,
    tier: string
  ) => {
    console.log("saveOrder", orderId, tenantId);
    const { cost, delivery, financial, opt } = mapPrices;
    const orderFields = fields ? getOrderFields(fields, t) : [];
    const orderState =
      tier === "commercial" || tier === "PLAN_PREMIUM" || tier === "PLAN_TRIAL"
        ? "PENDING"
        : "FREE_TIER";
    return fetch(
      "POST",
      "/api/saveOrder",
      {
        order: {
          _id: orderId,
          tenantId,
          items,
          totalPrice: cost,
          createdAt,
          currency,
          fields: orderFields,
          paymentMethod,
          state: orderState,
          coupon: mapPrices.couponCode
            ? mapPrices.couponCode.toUpperCase()
            : "",
          priceVar: {
            delivery: delivery ?? Number(0),
            financial: financial ?? Number(0),
            opt: opt ?? "message.noCost",
          },
        },
      },
      {
        Authorization: window.localStorage.getItem("token"),
      }
    )
      .then(() => console.info("Order save correctly"))
      .catch(async (res) => {
        // Backstop de precios: el server rechaza con 409 si los precios de la
        // orden no coinciden con la DB. Propagamos para frenar la redirección.
        if (res && typeof res.json === "function" && res.status === 409) {
          const body = await res.json().catch(() => null);
          if (body?.details) {
            throw {
              priceValidation: {isPriceOk: false, details: body.details},
            };
          }
        }
        console.warn("Saving order failed");
      });
  },
};
